import { pathFrom } from "../insights/insightsData";
import type { PathAnswer } from "../insights/pathCore";
import { session } from "../services/session";
import storage from "./storage";

/** The most common route for a range, from the server (SessionApi getCommonRoute): the one definition the Insights card and the red line both read. null when there is no usable answer. */
export const fetchCommonRoute = async (startDate: string, endDate: string): Promise<PathAnswer | null> => {
  const reply = await session({ id: 0, jsonprc: "2.0", method: "getCommonRoute", params: { siteId: storage.get("siteId"), startDate, endDate } });

  return pathFrom(reply?.data?.result);
};
